import { FC, memo, useEffect, useRef, useState } from 'react'
import styled from 'styled-components'

import { Box, HStack, Text, Token } from '@revolut-internal/ui-kit'

import { Tooltip } from 'components/Tooltip/Tooltip'
import { MAX_CHART_LEGEND_TEXT_WIDTH } from 'consts/chart'
import { BarChartLegendItem } from 'types'

const Item = styled(Box)<{ selected: boolean }>`
  border-radius: ${Token.radius.r4};
  padding: 0 ${Token.space.s6};
  background-color: ${({ selected }) =>
    selected ? Token.color.actionBackground : 'transparent'};
`

type ChartLegendItemProps = {
  item: BarChartLegendItem
}

export const ChartLegendItem: FC<ChartLegendItemProps> = memo(({ item }) => {
  const buttonTextRef = useRef<HTMLButtonElement>(null)
  const [buttonTextWidth, setButtonTextWidth] = useState(0)

  useEffect(() => {
    if (!buttonTextRef.current) {
      return
    }

    setButtonTextWidth(buttonTextRef.current.scrollWidth)
  }, [buttonTextRef])

  return (
    <Tooltip message={item.name} disabled={buttonTextWidth < MAX_CHART_LEGEND_TEXT_WIDTH}>
      <Item key={item.name} selected={item.selected}>
        <HStack align="center" space="s-4">
          <Box minWidth={8} size={8} bg={item.color} radius={Token.radius.r2} />

          <Text
            ref={buttonTextRef}
            variant="body3"
            maxWidth={MAX_CHART_LEGEND_TEXT_WIDTH}
            overflow="hidden"
            textOverflow="ellipsis"
            whiteSpace="nowrap"
          >
            {item.name}
          </Text>
        </HStack>
      </Item>
    </Tooltip>
  )
})
